import React from "react";
import { PageHelmet, Breadcrumb } from "../../component";

export const JobsPage = () => {
	return (
		<>
			<PageHelmet pageTitle="Eco² Building -  Karriere" />

			<Breadcrumb
				title="Jobs"
				parent={null}
				backgroundImage="./assets/images/bg/general-slide.jpg"
				showTree={false}
				customCSS={{
					minHeight: "70vh",
					display: "flex",
					alignItems: "center",
				}}
			/>
			<div className="rn-about-area ptb--120 bg_color--1">
				<div className="rn-about-wrapper">
					<div className="container">
						<div className="section-title">
							<p className="description">
								Diese Seite befindet sich noch im Aufbau. Bitte schauen Sie später wieder
								vorbei.
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
